import { useNavigate } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { getHotMovies, formatViews } from "@/utils/movie";

export default function HotRanking() {
  const navigate = useNavigate();
  const hot = getHotMovies(8);

  return (
    <section className="mt-10">
      <SectionHeading
        icon="ri-fire-line"
        title="热门电影榜单"
        subtitle="一周内最多点击，影迷都在看"
      />
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {hot.map((movie, i) => (
          <a
            key={movie.id}
            href={`/detail/${movie.id}`}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/detail/${movie.id}`);
            }}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-300 hover:bg-background-50 cursor-pointer"
          >
            <span
              className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                i < 3
                  ? "bg-accent-500 text-primary-950"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {i + 1}
            </span>
            <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={movie.poster}
                alt={`${movie.title} 海报`}
                title={`${movie.title} 免费在线观看`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
                {movie.title}
              </h3>
              <p className="mt-1 truncate text-xs text-foreground-500">
                {movie.year} · {movie.genres.slice(0, 2).join(" ")} · {movie.region}
              </p>
              <p className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 font-semibold text-accent-600">
                  <i className="ri-star-fill text-[10px]" />
                  {movie.rating.toFixed(1)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line text-[11px]" />
                  {formatViews(movie.views)}
                </span>
              </p>
            </div>
            <i className="ri-arrow-right-s-line text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600" />
          </a>
        ))}
      </div>
    </section>
  );
}